/* eslint-disable no-unused-vars */
import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import HomeIcon from "@mui/icons-material/Home";

import UserOrders from "./UsersOrders";
import SearchField from "../mui/SearchField";
import CustomDropdownMenu from "../mui/dropdown";
import ProgressDialog from "../mui/progressdialog";
import AlertDialog from "../mui/dialog";
import { loadAllUsers } from "../data/API";
import { getRegions } from "../data/models/GlobalAdmin";

import UserOrderDetail from "./UserOrderDetail";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";
const TITLE_HOME = "Users";
const TITLE_ORDERS = TITLE_HOME + " > User Orders";
const TITLE_ORDER_DETAIL = TITLE_HOME + " > Order Menu Items";

export default function User() {
  const [usersList, setUsersList] = React.useState(null);
  const [selectedUser, setSelectedUser] = React.useState(null);

  const [region, setRegion] = React.useState("");
  const [subRegion, setSubRegion] = React.useState("");

  const [regionsList, setRegionsList] = React.useState([]);
  const [subRegionsList, setSubRegionsList] = React.useState([]);
  const [isWarning, setIsWarning] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [menus, setMenus] = React.useState(null);

  const [state, setState] = React.useState(TITLE_HOME);

  const onUsersListItemClickCallback = (data) => {
    console.log(data);
    setSelectedUser(data);
    setState(TITLE_ORDERS);
  };

  const onBackClickListener = () => {
    if (state !== TITLE_HOME) {
      if (state === TITLE_ORDERS) {
        setState(TITLE_HOME);
      } else {
        setState(TITLE_ORDERS);
      }
    }
  };

  const onItemsSelection = (items) => {
    setMenus(items);
    console.log(items);
    setState(TITLE_ORDER_DETAIL);
  };

  function loadData() {
    if (usersList == null) {
      setIsLoading(true);
      setIsWarning(false);
      // console.log("called");
      loadAllUsers((err, data) => {
        if (err) {
          setIsLoading(false);
          console.log(err);
          setIsWarning(true);
        } else {
          console.log(data);
          setUsersList(data);
          getRegions((error2, regions) => {
            if (error2) {
              setIsWarning(true);
              console.log(error2);
              setIsLoading(false);
              return;
            } else {
              setIsLoading(false);
              setIsWarning(false);
              setRegionsList(regions);
              setSubRegionsList(regions[0].subregions);
            }
          });
        }
      });
    }
  }

  React.useEffect(() => {
    loadData();
  }, []);

  function getRegionFromName(n) {
    var region = null;
    console.log(regionsList);
    for (let i = 0; i < regionsList.length; i++) {
      if (n === regionsList[i].name) {
        region = regionsList[i];
      }
    }
    console.log("getRegionFromName");
    console.log(region);
    return region;
  }

  function getNamesFromRegions(list) {
    return list?.map((data) => {
      return data.name;
    });
  }

  function onRegionSelection(selectedNamedRegion) {
    setRegion(selectedNamedRegion);
    var sList = getRegionFromName(selectedNamedRegion).subregions;
    setSubRegionsList(sList);
    setSubRegion(sList[0]);
  }

  function onSubRegionSelection(selectedNamedSubRegion) {
    setSubRegion(selectedNamedSubRegion);
  }

  const UsersTable = () => {
    const [query, setQuery] = React.useState("");

    const getFilteredList = (list) => {


      if (
        region === "" ||
        subRegion === "" ||
        region.toLowerCase().includes("entire m")
      ) {
        const newList = [];

        list?.forEach((x) => {
          var queryCheck =
            x.first_name.toLowerCase().includes(query.toLowerCase()) ||
            x.last_name.toLowerCase().includes(query.toLowerCase()) ||
            x.id.toString().includes(query.toLowerCase()) ||
            query == "";

          if (queryCheck) {
            newList.push(x);
          }
        });
        return newList;
      } else {
        const newList = [];

        list?.forEach((x) => {
          var queryCheck =
            x.first_name.toLowerCase().includes(query.toLowerCase()) ||
            x.last_name.toLowerCase().includes(query.toLowerCase()) ||
            x.id.toString().includes(query.toLowerCase()) ||
            query == "";

          var regionCheck = false;

          if (x.region.toLowerCase().includes("entire m")) {
            regionCheck = true;
          } else if (
            x.region.toLowerCase() == region.toLowerCase() &&
            (x.subregion.toLowerCase() == subRegion.toLowerCase() ||
              subRegion.toLowerCase().includes("all " + region.toLowerCase()))
          ) {
            regionCheck = true;
          }

          if (queryCheck && regionCheck) {
            newList.push(x);
          }
        });
        return newList;
      }

    };

    return (
      <div >


        <ProgressDialog msg={"Loading Users"} visible={isLoading} />
        <AlertDialog
          warningMessage={
            "Something went wrong! please refresh page or connect with internet"
          }
          visible={isWarning}
        />
        <div >
          <div
            className="bg-white mx-2 rounded-md w-1/2"
            style={{
          display: "flex",
          flexDirection: "row",
          marginBlockEnd: "16px",
          overflowY: "auto",
        }}
          >
            <CustomDropdownMenu
              onSelection={onRegionSelection}
              width={170}
              label={"Region"}
              value={region}
              list={getNamesFromRegions(regionsList)}
            />
            <CustomDropdownMenu
              onSelection={onSubRegionSelection}
              width={170}
              label={"Sub Region"}
              value={subRegion}
              list={subRegionsList}
            />

            <SearchField setQuery={setQuery} query={query} />
          </div>
          <TableContainer sx={{ marginInlineStart: "10px" }} component={Paper}>
            <Table
              sx={{ minWidth: window.innerWidth / 1.4 }}
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontWeight: "600" }}>ID</TableCell>
                  <TableCell style={{ fontWeight: "600" }} align="left">
                    First Name
                  </TableCell>
                  <TableCell style={{ fontWeight: "600" }} align="left">
                    Last Name
                  </TableCell>
                  <TableCell style={{ fontWeight: "600" }} align="left">
                    Email
                  </TableCell>
                  <TableCell style={{ fontWeight: "600" }} align="left">
                    User Type
                  </TableCell>
                  <TableCell style={{ fontWeight: "600" }} align="left">
                    Phone
                  </TableCell>
                  <TableCell style={{ fontWeight: "600" }} align="left">
                    Status
                  </TableCell>
                  <TableCell style={{ fontWeight: "600" }} align="left">
                    Region
                  </TableCell>
                  <TableCell style={{ fontWeight: "600" }} align="left">
                    Sub Region
                  </TableCell>
                  <TableCell style={{ fontWeight: "600" }} align="left">
                    Total Orders
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {getFilteredList(usersList)?.map((rowData, key) => (
                  <TableRow
                    onClick={() => onUsersListItemClickCallback(rowData)}
                    className="cursor-pointer hover:bg-yellow-200"
                    key={key}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>{rowData.id}</TableCell>
                    <TableCell align="left">{rowData.first_name}</TableCell>
                    <TableCell align="left">{rowData.last_name}</TableCell>
                    <TableCell align="left">{rowData.email}</TableCell>
                    <TableCell align="left">{rowData.user_type}</TableCell>
                    <TableCell align="left">{rowData.phone}</TableCell>
                    <TableCell align="left">{rowData.status}</TableCell>
                    <TableCell align="left">{rowData.region}</TableCell>
                    <TableCell align="left">{rowData.subregion}</TableCell>
                    <TableCell align="left">{rowData.orders?.length}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    );
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          marginBlockEnd: "16px",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            borderRadius: "10px",
            padding: 8,
            background: "red",
            display: "inline-flex",
            flexDirection: "row",

            boxShadow: "1px 1px 5px 2px rgb(0,0,0,0.2)",
          }}
        >
          <HomeIcon
            onClick={() => {
              setState(TITLE_HOME);
            }}
            sx={{
              color: "white",
              alignSelf: "center",
              marginInlineEnd: 1,
            }}
          />
          {state !== TITLE_HOME ? (
            <ArrowBackIosIcon
              onClick={onBackClickListener}
              sx={{
                color: "white",
                alignSelf: "center",
                marginInlineEnd: 1,
                marginInlineStart: 1,
              }}
            />
          ) : (
            ""
          )}
          <h1
            style={{
              color: "rgb(255, 255, 255)",
              fontSize: 20,
            }}
          >
            {state}
          </h1>
        </div>
      </div>
      <div
        style={{
          height: window.innerHeight - 100,
          overflow: "auto",
        }}
      >
        {state === TITLE_HOME ? (
          <UsersTable />
        ) : state === TITLE_ORDERS ? (
          <UserOrders user={selectedUser} onItemsSelection={onItemsSelection} />
        ) : state === TITLE_ORDER_DETAIL ? (
          <UserOrderDetail menus={menus} />
        ) : (
          <p>404 Not Found</p>
        )}
      </div>
    </div>
  );
}
